import gql from "graphql-tag"
import fullPaymentOrder from "../fragments/fullPaymentOrder"

const query = gql`
  query PaymentOrder($id: ID!) {
    paymentOrder(id:$id) {
      ...fullPaymentOrder
    }
  }
  ${fullPaymentOrder}
`

export const toString = query.loc.source.body

export default query
